var CleverTapService = function () {
  function CleverTapService() {}
  CleverTapService.validateAndExecute = function (userData, executeFn) {
    if (!window.clevertap) {
      return;
    }
    if (!userData) {
      return;
    }
    executeFn(userData);
  };
  CleverTapService.scheduleUserLogin = function (userData) {
    if (CleverTapService.userLoginTimeoutId) {
      clearTimeout(CleverTapService.userLoginTimeoutId);
      CleverTapService.userLoginTimeoutId = null;
    }
    CleverTapService.userLoginTimeoutId = setTimeout(function () {
      CleverTapService.validateAndExecute(userData, CleverTapService.executeUserLogin);
      CleverTapService.userLoginTimeoutId = null;
    }, CleverTapService.DELAY_MS);
  };
  CleverTapService.scheduleRegistrationDone = function (userData) {
    if (CleverTapService.registrationDoneTimeoutId) {
      clearTimeout(CleverTapService.registrationDoneTimeoutId);
      CleverTapService.registrationDoneTimeoutId = null;
    }
    CleverTapService.registrationDoneTimeoutId = setTimeout(function () {
      CleverTapService.validateAndExecute(userData, CleverTapService.executeRegistrationDone);
      CleverTapService.registrationDoneTimeoutId = null;
    }, CleverTapService.DELAY_MS);
  };
  CleverTapService.userLoginTimeoutId = null;
  CleverTapService.registrationDoneTimeoutId = null;
  CleverTapService.DELAY_MS = 3000;
  CleverTapService.executeRegistrationDone = function (userData) {
    CleverTapService.executeUserLogin(userData);
    window.clevertap.event.push('registration_done', {
      action: 'sign_up',
      identity: userData.id
    });
  };
  CleverTapService.executeUserLogin = function (userData) {
    try {
      var userLanguage = navigator.language || navigator.userLanguage || 'en-US';
      var language = userLanguage.split('-')[0];
      var did = localStorage.getItem('paa_did') || '';
      window.clevertap.profile.push({
        Site: {
          Language: language
        }
      });
      if (window.clevertap.addMultiValueForKey) {
        window.clevertap.addMultiValueForKey('device_id', did);
      }
      if (!localStorage.getItem('ct_wzrk')) {
        localStorage.setItem('ct_wzrk', 'set');
        window.clevertap.onUserLogin.push({
          Site: {
            Name: userData.username,
            Identity: userData.id,
            Email: userData.email,
            Language: language
          }
        });
      }
    } catch (error) {
      console.error("CleverTap user login error: ".concat(error instanceof Error ? error.message : String(error)));
    }
  };
  return CleverTapService;
}();

export { CleverTapService as default };
//# sourceMappingURL=index.js.map
